import ApiServices from "@/services/uteis/ApiServices.js";
import route from "@/libs/endPoint/avaliacaoinstitucional/AvaliacaoInstitucionalRoutes";
//import store from "@/store/index.js";
class AvaliacaoInstitucionalServices {
  validarUsuarioQuestionario(params) {
    try {
      const url = route.validarUsuario;
      return ApiServices.post(url, params);
    } catch (error) {
      console.error("Erro ao validar usuário para o questionário:", error);
      throw error;
    }
  }

  async questiuonariosServidoresAvaliacao() {
    try {
      const url = route.questionariosServidores;
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async instituicaoHabilitadaProcesso(id) {
    try {
      const url = route.instituicaoHabilitadas(id);
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async responderAdministrativo(paramters) {
    try {
      const url = route.responderAdministrativo;
      const { data } = await ApiServices.post(url, paramters);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async administrativosRespondidas(id_questionario) {
    try {
      const url = route.respondidasAdministrativo(id_questionario);
      const { data } = await ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async analiseAvaliacaoResponsavel() {
    try {
      const url = route.analiseAvaliacaoResponsavel;
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async andamentoAvaliacaoFamilia() {
    try {
      const url = route.andamentoAvaliacaoFamilia;
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async gerarDevolutiva(params) {
    try {
      const url = route.devolutiva;
      const { data } = await ApiServices.post(url, params);
      return data;
    } catch (error) {
      console.error("Error generating devolutiva:", error);
      throw error;
    }
  }

  async listarDevolutivas(ano) {
    try {
      const url = route.devolutivaDiretorio(ano);
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading devolutivas:", error);
      throw error;
    }
  }

  async listarArquivosDevolutiva(ano, instituicao) {
    try {
      const url = route.devolutivaArquivos(ano, instituicao);
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading devolutiva files:", error);
      throw error;
    }
  }

  async baixarDevolutiva(ano, instituicao, arquivo) {
    try {
      const url = route.devolutivaDownload(ano, instituicao, arquivo);
      const response = await ApiServices.getBlob(url);
      return response.data;
    } catch (error) {
      console.error("Error downloading devolutiva:", error);
      throw error;
    }
  }

  async removerDevolutiva(ano, instituicao, arquivo) {
    try {
      const url = route.removePdefDevolutiva(ano, instituicao, arquivo);
      const { data } = await ApiServices.delete(url);
      return data;
    } catch (error) {
      console.error("Error removing devolutiva:", error);
      throw error;
    }
  }

  async relatorioNotaFinal(id_processo) {
    try {
      const url = route.relatorioNotaFinal(id_processo);
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading relatorio nota final:", error);
      throw error;
    }
  }
}
export default new AvaliacaoInstitucionalServices();
